var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdobeAnalytics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "adobe_analytics-a",
    d: "M0,21.42 C0,33.250814 9.58918605,42.84 21.42,42.84 C33.250814,42.84 42.84,33.250814 42.84,21.42 C42.84,9.58918605 33.250814,0 21.42,0 C9.58918605,0 0,9.58918605 0,21.42 Z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "adobe_analytics-b",
    cx: "39.868%",
    cy: "33.311%",
    r: "66.75%",
    fx: "39.868%",
    fy: "33.311%",
    gradientTransform: "matrix(.97917 0 0 1 .008 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#33284E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "76.69%",
    stopColor: "#130732"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.42 .42)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "adobe_analytics-c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#adobe_analytics-a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#9F7FFF",
    xlinkHref: "#adobe_analytics-a"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 50.4,
    height: 49.35,
    x: -3.78,
    y: -3.15,
    fill: "url(#adobe_analytics-b)",
    mask: "url(#adobe_analytics-c)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2D8FF",
    fillRule: "nonzero",
    d: "M17.01,22.05 L15.015,22.05 L15.015,35.154 C15.624,35.469 16.359,35.721 17.01,35.952 L17.01,22.05 Z M20.685,21.21 L20.685,36.666 C20.958,36.687 21.378,36.813 21.651,36.813 C22.008,36.813 22.323,36.813 22.68,36.792 L22.68,21.21 L20.685,21.21 Z M32.13,32.172 C32.844,31.416 33.579,30.513 34.125,29.631 L34.125,19.635 L32.13,19.635 L32.13,32.172 Z M10.269,22.89 L14.868,17.577 L19.236,19.215 L28.581,12.516 L33.285,16.968 L35.658,15.078 L35.301,14.301 L33.327,15.96 L28.686,11.634 L19.194,18.417 L14.784,16.716 L9.87,22.26 L6.804,22.974 L6.804,23.688 L10.269,22.89 Z M11.235,26.04 L9.24,26.04 L9.24,29.904 C9.786,30.744 10.521,31.542 11.235,32.256 L11.235,26.04 Z M28.455,17.22 L26.46,17.22 L26.46,35.889 C27.111,35.658 27.846,35.385 28.455,35.049 L28.455,17.22 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9F7FFF",
    d: "M0.168,21.84 C0.168,33.81 9.87,43.512 21.84,43.512 C33.81,43.512 43.512,33.81 43.512,21.84 C43.512,9.87 33.81,0.168 21.84,0.168 C9.87,0.168 0.168,9.87 0.168,21.84 Z M2.394,21.84 C2.394,11.088 11.109,2.373 21.84,2.373 C32.571,2.373 41.286,11.088 41.286,21.84 C41.286,32.592 32.571,41.307 21.84,41.307 C11.109,41.307 2.394,32.592 2.394,21.84 Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdobeAnalytics);
export default __webpack_public_path__ + "static/media/AdobeAnalytics.ad086286.svg";
export { ForwardRef as ReactComponent };